import FilterParameterDto from "../datasourcemodule/FilterParameterDto";
import DataTableFieldParameterDefinitionDto from "../datasourcemodule/DataTableFieldParameterDefinitionDto";

class PathMetaApiMappingDto {
    FieldReferenceId: number;
    TransformationLogicId: number;
    TransformationParameters: string;
    TechnicalName: string;
    IsSelected: boolean;
    Filters: FilterParameterDto[];
    DeclaredVariables: DataTableFieldParameterDefinitionDto[];

    constructor(
        fieldReferenceId: number,
        transformationLogicId: number,
        transformationParameters: string,
        technicalName: string,
        isSelected: boolean = true,
        filters: FilterParameterDto[],
        declaredVariables: DataTableFieldParameterDefinitionDto[] = []
    ) {
        this.FieldReferenceId = fieldReferenceId;
        this.TransformationLogicId = transformationLogicId;
        this.TransformationParameters = transformationParameters;
        this.TechnicalName = technicalName;
        this.IsSelected = isSelected;
        this.Filters = filters;
        this.DeclaredVariables = declaredVariables;
    }
}

export default PathMetaApiMappingDto;
